import React from 'react';

import { createRoot } from 'react-dom/client';

import App from './App';
import AppIntlProvider from './intl/AppIntlProvider';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <AppIntlProvider>
      <App />
    </AppIntlProvider>
  </React.StrictMode>
);
